export const sizes = {
  smallMobile: '320px',
  mobile: '480px',
  phablet: '560px',
  tablet: '768px',
  laptop: '1024px',
  desktop: '1280px',
  largeDesktop: '1440px',
};
